import each from 'lodash/each';
import isObject from 'lodash/isObject';
import isObjectLike from 'lodash/isObjectLike';
import find from 'lodash/find';
import get from 'lodash/get';
import identity from 'lodash/identity';
import isEmpty from 'lodash/isEmpty';
import keys from 'lodash/keys';
import pickBy from 'lodash/pickBy';
/**
 * Concatenates params to generate a string usable in a URL.
 * @param { any[] } collection List of elements to convert to query params
 * @param { any[] } preserveFalsy Preserves falsy values : null, undefined, 0 in the result string
 * @returns { string } String preceded by '?' and the params separated by '&'
 */
export function toQueryString(collection, preserveFalsy = true) {
    if (isEmpty(collection)) {
        return '';
    }
    const dataObject = preserveFalsy ? collection : pickBy(collection, identity);
    const query = keys(dataObject)
        .map(key => {
        return `${key}=${encodeURIComponent(dataObject[key])}`;
    })
        .join('&');
    return `?${query}`;
}
/**
 * Returns the predicate found on a recursive collection
 * @param { any[] } collection
 * @param { string } deepCollectionName
 * @param predicate
 * @returns { any }
 */
export function findDeep(collection, deepCollectionName, predicate) {
    let result = find(collection, predicate);
    if (result) {
        return result;
    }
    each(collection, item => {
        if (get(item, deepCollectionName, []).length) {
            result = findDeep(item[deepCollectionName], deepCollectionName, predicate);
        }
        return result ? result : false;
    });
    return result;
}
/**
 * Returns the received object as flat
 * @param { Record<string, any> } object
 * @param { any } currentKey
 * @example
 * flatObject({ foo: { children: 1 }}) => { 'foo.children': 1 }
 * flatObject({ foo: { children: { grandchild: 2 }}}) => { 'foo.children.grandchild': 2 }
 * @returns { Record<string, any> }
 */
export function flatObject(object, currentKey = '') {
    let result = {};
    each(keys(object), key => {
        const temporaryKey = currentKey ? `${currentKey}.${key}` : key;
        const objectValue = get(object, key);
        result = isObject(objectValue)
            ? Object.assign(Object.assign({}, result), flatObject(objectValue, temporaryKey)) : Object.assign(Object.assign({}, result), { [temporaryKey]: objectValue });
    });
    return result;
}
/**
 * Performs recursive deep merge for two objects
 * Serves as an alternative for lodash util `merge` due to the fact that lodash depends on `buffer` which that is not supported by Webpack 5
 * @param { Record<string, any> } baseObject - initial object
 * @param { Record<string, any> } extend - extending or overwriting object
 * @returns { Record<string, any> } - result of the deep merge
 */
export function deepMergeObjects(baseObject = {}, extend = {}) {
    for (const property in extend) {
        if (isObjectLike(baseObject[property])) {
            deepMergeObjects(baseObject[property], extend[property]);
        }
        else {
            baseObject[property] = extend[property];
        }
    }
    return baseObject;
}
